__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/8f6f668/_next/";